import PropTypes from "prop-types";
import { createContext, useContext, useState } from "react";
import api from "../common/api/api";
import { toast } from "react-toastify";
import { routes } from "../../src/routes";
import { useNavigate } from "react-router";
import { removeUserCookies, setUserCookies } from "../common/api/apiConfig";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [loading, setLoading] = useState(false);
    const [dashboardData, setDashboardData] = useState([]);
    const [notificationData, setNotificationData] = useState([]);
    const [notificationCount,setNotificationCount]=useState([]);
    const navigate = useNavigate();


    const userLogin = async (request) => {
        setLoading(true);
        try {
            const response = await api.auth.userLogin(request);
            if (response?.data) {
                setLoading(false);
                const userData = response?.data;

                if (userData?.type === "ADMIN") {
                    toast.success(response?.message || "Login successful!");
                    setUserCookies(userData);
                    setLoading(false)
                    return response;
                } else {
                    setLoading(false)
                    toast.error("Invalid user type");
                    return null;
                }
            } else {
                setLoading(false)
                toast.error(response?.message);
            }

        } catch (error) {
            toast.error(error?.response?.message || "Something went wrong!");
        } finally {
            setLoading(false);
        }
    };


    const signUp = async (request) => {
        setLoading(true);
        try {
            const response = await api.auth.register(request);
            if (response?.success) {
                toast.success(response?.message || "User signup failed!");
                navigate(routes.SIGNIN);
            }
            return response;
        } catch (error) {
            toast.error(error?.response?.data?.message || "Something went wrong!");
        } finally {
            setLoading(false);
        }
    };

    const userSignout = () => {
        try {
            toast.success("Logged out successfully!");
            removeUserCookies();
            localStorage.clear();
            navigate(routes.LOGIN);
        } catch (error) {
            toast.error("Something went wrong!");
        } finally {
            setLoading(false);
        }
    };


    const getDashboardData = async () => {
        setLoading(true);
        try {
            const response = await api.auth.getDashBoardCount();
            if (response?.success) {
                setLoading(false);
                setDashboardData(response?.data);
            }

        } catch (error) {
            setLoading(false);
            toast.error(error?.response?.message || "Something went wrong!");
        }
        finally {
            setLoading(false);
        }
    };

    const topicsNotification = async (request) => {
        setLoading(true);
        try {
            const response = await api.auth.getTopicsNotification(request)
            if (response?.success) {
                setLoading(false);
                setNotificationData(response?.data.docs)
                setNotificationCount(response?.data?.totalDocs)
            }
        } catch (error) {
            setLoading(false);
            toast.error(error?.response?.message || "something went wrong!")
        }
        finally {
            setLoading(false)
        }
    }



    const contextValue = {
        loading,
        userLogin,
        signUp,
        userSignout,
        getDashboardData,
        dashboardData,
        topicsNotification,
        notificationData,
        notificationCount,
    };

    return (
        <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>
    );
};

AuthProvider.propTypes = {
    children: PropTypes.node,
};

export const useAuth = () => useContext(AuthContext);
